import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function CategorySection() {
  return (
    <section className="w-full px-4 md:px-6 py-8">
      <div className="flex items-center gap-3 overflow-x-auto pb-2 scrollbar-hide">
        {categories.map((cat) => (
          <Link
            key={cat.slug}
            to={cat.slug === 'all' ? '/category/all' : `/category/${cat.slug}`}
            className="flex items-center gap-2 px-4 py-2.5 rounded-full border border-background-200/80 bg-background-50 hover:border-primary-300 hover:bg-primary-50 transition-all duration-200 whitespace-nowrap no-underline flex-shrink-0"
          >
            <span className="w-5 h-5 flex items-center justify-center text-primary-500">
              <i className={`${cat.icon} text-sm`}></i>
            </span>
            <span className="text-sm font-medium text-foreground-700">{cat.name}</span>
          </Link>
        ))}
      </div>
    </section>
  );
}